import React, { useEffect, useState, Fragment } from "react";
import ReactDOM from "react-dom";
// import PageManager from "../page-manager";
import useAPI from "./Configurator/hooks/useAPI";
import LazyLoad from "react-lazyload";
import Products from "./products";
import GroupItem from "./group-item";

const Groups = ({
  forCategory,
  level,
  childGroups,
  context,
  shouldShowProducts,
  onFilterChange,
  titleSuffix,
}) => {
  const [showChildGroups, setShowChildGroups] = useState(false);
  const [showProducts, setShowProducts] = useState(shouldShowProducts);
  const [groups, setGroups] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState("all");
  const [selectedGroup, setSelectedGroup] = useState(null);
  const { API } = useAPI();
  useEffect(() => {
    if (!childGroups) {
      getAndSetGroups();
    } else {
      setGroups(childGroups);
    }
    if (level === 3) {
      setShowProducts(true);
    }
  }, [forCategory, level, childGroups]);

  //   useEffect(() => {
  //     if (selectedGroupId !== "all") {
  //       setSelectedGroup(groups.find((g) => g._id === selectedGroupId));
  //     } else {
  //       setSelectedGroup(null);
  //     }
  //   }, [selectedGroupId, groups]);

  const getAndSetGroups = async () => {
    let data = await API.get(
      `/groups?forCategory=${forCategory}&level=${level}`
    );
    setGroups(data.groups);
  };

  const goToPage = (url) => {
    window.location.href = url;
  };

  const handleChange = (e, group) => {
    setSelectedGroupId(group?._id || "all");
    console.log("handleChange", group);
    setSelectedGroup((group?._id && group) || null);
    // setShowChildGroups(true);
    console.log("handleChange", group);
    onFilterChange &&
      onFilterChange({
        groupId: group?._id,
        level: group?.level,
        forCategory: group?.forCategory || forCategory,
      });
    e.stopPropagation();
  };

  return (
    <div>
      {groups.length > 0 && (
        <div>
          <div
            className="sb-configurable-groups-nav container sb-mobile-only"
            style={{ marginBottom: "15px" }}
          >
            <select
              value={selectedGroupId}
              onChange={(e) => {
                // handleChange(e, group);
                handleChange(e);
              }}
            >
              <option value="all">All {titleSuffix ? titleSuffix : ""}</option>
              {groups.map((groupMap) => {
                console.log("groupMap", groupMap, groups);
                return (
                  <option key={groupMap._id} value={groupMap._id}>
                    {groupMap.name}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="sb-configurable-groups-nav container sb-desktop-only">
            {selectedGroup && level !== 3 && (
              <div
                onClick={() => {
                  setSelectedGroup(null);
                }}
                className="sb-hoverable"
                style={{
                  padding: "10px",
                  color: "black",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    backgroundColor: "#fd6630",
                    color: "white",
                    borderRadius: "50px",
                    width: "25px",
                    height: "25px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  X
                </span>
                &nbsp;
                {selectedGroup.name}
              </div>
            )}
            {(!selectedGroup || level === 3) && (
              <Fragment>
                <div className={selectedGroupId === "all" && "selected"}>
                  <GroupItem
                    name={`All ${titleSuffix ? titleSuffix : ""}`}
                    link="?"
                    forCategory={forCategory}
                    onClick={(e) => {
                      handleChange(e, null);
                    }}
                    level={level}
                  />
                </div>
                {groups.map((groupMap) => {
                  let groupUrl = "?group=" + groupMap._id;
                  return (
                    <div
                      key={groupMap._id}
                      className={groupMap._id == selectedGroupId && "selected"}
                    >
                      <GroupItem
                        name={groupMap.name}
                        link={groupUrl}
                        forCategory={forCategory}
                        onClick={(e) => {
                          handleChange(e, groupMap);
                        }}
                        level={groupMap.level}
                      />
                    </div>
                  );
                })}
              </Fragment>
            )}
          </div>
          {selectedGroup && (
            <div style={{ display: "block" }}>
              <Groups
                forCategory={forCategory}
                level={level + 1}
                childGroups={selectedGroup.childGroups}
                context={context}
                onFilterChange={onFilterChange}
                titleSuffix={selectedGroup.name}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Groups;
